module.exports = __webpack_public_path__ + "img/location.bf6dba6c.svg";